"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineById = void 0;
const getOrderLineById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_lines")
        .select(`*, 
        versions:order_line_versions!order_line_id(
          *
        )`)
        .eq("id", id)
        .single();
    if (error) {
        console.log("ERROR GETTING ORDER LINE BY ID", error);
        throw new Error(error.message);
    }
    return data;
};
exports.getOrderLineById = getOrderLineById;
